import { Controller } from "@hotwired/stimulus";

// Horizontal wizard stepper. On phones only the first three pills fit, so
// without this the current step sits off-screen from step 4 onward and the
// applicant sees three checkmarks and nothing else (issue #87).
export default class extends Controller {
  connect() {
    const current = this.element.querySelector('[aria-current="step"]');
    if (!current) return;

    const list = this.element.getBoundingClientRect();
    const pill = current.getBoundingClientRect();
    if (pill.left >= list.left && pill.right <= list.right) return;

    // Scroll only the list, never the page: scrollIntoView would also yank
    // the window to the stepper on every step change.
    this.element.scrollLeft +=
      pill.left - list.left - (list.width - pill.width) / 2;
  }
}
